import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;
declare var page: any;

export class websiteUsersImport_template extends vnTemplate {

    protected brandsFilter: filterDropdown_template;
    protected mailingListFilter: multipleSelector_template;

    protected getTemplateHtml(): string {

        return /*html*/ `
        <div class="ww-form">
            <div class="w-form">

                <div class="form-header">
                    <h3 class="form-title" data-bind="">Import Newsletter Subscriptions</h3>
                    <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                </div>

                <div class="w-form-body">
                    
                    <div class="form-body">

                        <span class="form-sub-title" style="padding: 1rem; width: auto;">This tool allows for the import of newsletter subscriptions in bulk. CSV file uploads should contain 3 columns with headers for “firstName”, “lastName”, and “email”. Values can be left empty as needed. Accepted files will be processed within an hour.”</span>
                        
                        <div class="form-group">
                            <form>
                                <input class="input-file-btn icon i-upload" id="csvFile" name="csvFile" type="file" accept=".csv" data-bind="event: { change: onFileSelected }" class="input-file-btn">
                            </form> 
                        </div> 

                        <div class="form-group">
                            <label for="logoUrl" class="form-label">Brand</label>
                            ${ this.brandsFilter.getHtmlBuild() }
                        </div>

                        <div class="form-group">
                            ${ this.mailingListFilter.getHtmlBuild() }
                            <div style="display: none;" id="selected-mailing-lists" class="selected-mailing-lists"></div>
                        </div>

                        <div class="form-group">
                            <label for="logoUrl" class="form-label">Source</label>
                            <input id="source" data-bind="value: source" type="text" class="input-text">
                        </div>

                        <div class="form-group">
                            <label for="logoUrl" class="form-label">Medium</label>
                            <input id="medium" data-bind="value: medium" type="text" class="input-text">
                        </div>

                        <div class="form-group">
                            <label for="logoUrl" class="form-label">Campaign</label>   
                            <input id="campaign" data-bind="value: campaign" type="text" class="input-text">
                        </div>

                    </div>

                    <div class="form-footer">
                        <button type="button" data-bind="event: { click: onClickCancel }" class="btn" >Cancel</button>
                        <button type="button" class="btn highlight icon" data-bind="event: { click: onClickImportSummary.bind($data, 'summary') }">Import</button>
                    </div>
                </div>

                <div id="summary-dialog" class="w-lightbox light-theme">

                    <div class="lightbox-content import-user-summary">
                            
                        <div class="w-form lightbox-form">
                        
                            <div class="form-header">

                                <h3 class="form-title">Import Newsletter Subscriptions</h3>
                                <button type="button"  data-bind="event: { click: onClickHideSummaryDialog }" class="close-button icon i-close-2"></button>

                            </div>
                        
                            <div class="form-body">

                                    <div class="form-group import-summary" data-bind="if: summary() !== null">
                                    
                                        
                                        <span class="form-sub-title" data-bind="text: summary().newUsersCount + ' newly created website users will be subscribed to the following mailing lists on ' +  (summary().brand ? summary().brand.name + ' :' : '') + (summary().mailingListNames != '' ? summary().mailingListNames : '')"></span></br>
                                    
                                        <div id="spec_section_list" data-bind="visible: summary().mailingListsCount !== null">
                                            <ul data-bind="foreach: summary().mailingListsCount">
                                                <li><span  data-bind="text: $data.count + ' existing website users will be subscribed to ' + $data.mailingList.name"></span></li>
                                            </ul>
                                        </div>
                                        <ul>
                                            <li><span data-bind="visible: source() != '' || medium() != '' || campaign() != '', text:'For all new subscriptions, ' + (source()  ? 'source will be set to ' + source() : '') + (medium() ? ', medium will be set to ' + medium() : '') + (campaign() ? ', campaign will be set to ' + campaign() : '') "></span></li>
                                            <li><span data-bind="text: summary().firstNameCount + ' first names will be added to website users since they previously did not have one set. No existing first names will be overwritten.' "></span></li>
                                            <li><span data-bind="text: summary().lastNameCount + ' last names will be added to website users since they previously did not have one set. No existing last names will be overwritten.' "></span></li>
                                        </ul>

                                    </div>
                            </div>
                    
                            <div class="form-footer">

                                <button type="button" data-bind="event: { click: onClickHideSummaryDialog }" class="btn">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickImportSave.bind($data, 'save') }" class="btn highlight">Confirm</button>

                            </div>

                        </div>
                        
                    </div>

                </div>

            </div>
        </div>
        `;
    }

    protected initPartial(): void {

        this.mailingListFilter = new multipleSelector_template("mailingListFilter", this.getTemplateViewModel(), this.caller);
        this.mailingListFilter.setLabel("Mailing Lists");
        this.mailingListFilter.setFilterContainerClass('margin-neg');
        this.mailingListFilter.setTagContainerId('selected-mailing-lists');
        this.mailingListFilter.setTagContainerCaption('Selected mailing lists:');

        this.brandsFilter = new filterDropdown_template('brandFilter', this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setLabel('Template');
        
    }

    protected getTemplateName(): string {

        return "websiteUsersImport_template";
    }

    protected buildViewModel(): any {

        let huit_neuf_this = this;
        return {
            csvFile: ko.observable(null),
            source : ko.observable(''),
            medium : ko.observable(''),
            campaign : ko.observable(''),
            summary : ko.observable(''),
            mailingLists: ko.observableArray([]),
            onClickCancel: function (data, event) {
                huit_neuf_this.onCancel();
            },
            onFileSelected: function (data, event) {
                huit_neuf_this.onFileSelected(data, event);
            },
            onClickImportSummary: function (type,data, event) {
                huit_neuf_this.saveImport(type);
            },
            onClickHideSummaryDialog : (data, event) =>{
                huit_neuf_this.toggleSummaryDialogVisibility()
            },
            onClickImportSave : (type, data, event) =>{
                huit_neuf_this.saveImport(type)
            }
        }
    }
    public getViewModelForRequest() {
        
        return {
            csvFile: this.getTemplateViewModel().csvFile(),
            brandId: this.brandsFilter.getTemplateViewModel().selectedOption(),
            mailingListIds: this.mailingListFilter.getTemplateViewModel().selectedItems(),
            source: this.getTemplateViewModel().source(),
            medium: this.getTemplateViewModel().medium(),
            campaign: this.getTemplateViewModel().campaign(),
        }
    }

    private onFileSelected(data, event) {

        var file = event.target.files[0];
        if (file) {
            this.getTemplateViewModel().csvFile(file);
        }
    }

    public onCancel() {
        
        this.caller.redirectToList();
    }

    public setBrands(options) {

        options.unshift({'id':null,'name':'Select An Option'});
        this.brandsFilter.setOptions(options);
    }
    
    public setMailingLists(options) {

        this.getTemplateViewModel().mailingLists(options);
    }
    
    public setSummary(summary) {

        this.getTemplateViewModel().summary(summary);
    }

    public toggleSummaryDialogVisibility() {

        document.getElementById('summary-dialog').classList.toggle('is-visible');
    }

    private saveImport(type) {

        this.caller.saveImport(type);
    }

    public updateMailingList() {

        let primaryMailingList = [];
        let mailingLists = this.getTemplateViewModel().mailingLists();
        let selectedBrand = this.brandsFilter.getTemplateViewModel().selectedOption();

        mailingLists = mailingLists.filter(mailingList => mailingList.idBrand == selectedBrand);
        
        //make isPrimary disbale
        mailingLists.forEach(element => {
            if(element.isPrimary == '1'){
                primaryMailingList.push(element);
            }
        });

        //set mailing lists
        this.mailingListFilter.setItems([]);
        this.mailingListFilter.setItems(mailingLists);
        
        //set selected mailing list
        this.mailingListFilter.setSelectedItems([]);
        this.mailingListFilter.setSelectedItems(primaryMailingList);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/websiteUsersImport_template.ts